import { rd } from '@passionware/monads';
import {
  FeatureFlagSource,
  FeatureGroupDefinition
} from '../feature-management';

export function createFeatureSourceChain<
  Config extends FeatureGroupDefinition,
  Query = void
>(
  sources: FeatureFlagSource<Config, Query>[]
): FeatureFlagSource<Config, Query> {
  return {
    useFeatureFlags: query => {
      const remoteDatas = sources.map(source => source.useFeatureFlags(query));
      // rd.combineAll turns idle + success into an error, so an unresolved
      // query on any source has to short-circuit the whole chain.
      const isIdle = remoteDatas.some(data => rd.isIdle(data));
      const combined = isIdle ? rd.ofIdle() : rd.combineAll(remoteDatas);

      return rd.useMemoMap(combined, sourceValues =>
        Object.assign({}, ...sourceValues)
      );
    },
    getFeatureFlags: async query => {
      const flags = await Promise.all(
        sources.map(source => source.getFeatureFlags(query))
      );
      return Object.assign({}, ...flags);
    }
  };
}
